'use strict';

var _ = require('lodash');
var FOCityAptsService = function FOCityAptsService(restangular, App) {
  function loadFoCityApts() {
    App.cityapts = App.cityapts || [];
    return getFoCityApts().then(function (response) {
      var foCityApts = response.cityApts;
      App.cityapts = processFoCityApts(foCityApts);
    });
  }
  function getUniqueFoCityAptsByOrigDest(foCityApts) {
    return _.chain(foCityApts).map(function (item) {
      return _.pick(item, ['origin', 'destination']);
    }).uniqBy(function (item) {
      return item.origin + item.destination;
    }).value();
  }
  function removeCityAptsDuplicates(uniqueFoCityApts) {
    var foCityAptsToBeDeleted = [];
    _.forEach(App.cityapts, function (appCityApts) {
      var foCityApts = _.find(uniqueFoCityApts, {
        origin: appCityApts.origin,
        destination: appCityApts.destination
      });
      if (!_.isNil(foCityApts)) {
        _.merge(appCityApts, foCityApts);
        _.remove(uniqueFoCityApts, foCityApts);
      }
      if (_.isNil(foCityApts) && !_.isNil(_.find(App.cityapts, {
        origin: appCityApts.origin,
        destination: appCityApts.destination
      }))) {
        foCityAptsToBeDeleted.push(appCityApts);
      }
    });
    _.forEach(foCityAptsToBeDeleted, function (appfoCityApts) {
      var foCityApts = _.find(App.cityapts, {
        origin: appfoCityApts.origin,
        destination: appfoCityApts.destination
      });
      var cityAptsCopy = App.cityapts.slice();
      _.remove(cityAptsCopy, foCityApts);
      App.cityapts = cityAptsCopy;
    });
  }
  function processFoCityApts(foCityApts) {
    var uniqueFoCityApts = getUniqueFoCityAptsByOrigDest(foCityApts);
    var uniqueFoCityAptsCache = _.cloneDeep(uniqueFoCityApts);
    removeCityAptsDuplicates(uniqueFoCityApts);
    App.foCityApts = uniqueFoCityAptsCache;
    return _.chain(App.cityapts).concat(uniqueFoCityApts).uniqBy(function (item) {
      return item.origin + item.destination;
    }).value();
  }
  function getFoCityApts() {
    return restangular.one('external').one('faresoptimizer').one('focityapts').get({
      pageLimit: -1
    });
  }
  return {
    loadFoCityApts: loadFoCityApts
  };
};
FOCityAptsService.$inject = ['Restangular', 'App'];
module.exports = FOCityAptsService;